import React from "react";

function SectionHeading({ children, className = "", ...rest }) {
  return (
    <h4
      className={`h5 fw-bold text-dark mb-0 ${className}`.trim()}
      style={{
        paddingLeft: "10px",
        borderLeft: "3px solid var(--brand-color-1)",
      }}
      {...rest}
    >
      {children}
    </h4>
  );
}

export default SectionHeading;
